import React from 'react'
import { Typography, Box, Grid } from '@mui/material';

import { RiInstagramLine } from "react-icons/ri";
import { FaGithub } from "react-icons/fa";

import { FaLinkedinIn } from "react-icons/fa";
import Avatar from '@mui/material/Avatar';

import { tokens } from '../../theme';
import { useTheme } from '@mui/material';
export const Footer = () => {
    let date = new Date();
    let year = date.getFullYear();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    return (
        <Grid item xs={12} display='flex' flexDirection='row' justifyContent='space-between' m={2} alignContent='center' gap={2} height={50}>
            <Box>
                <Typography variant='h6'>Designed and Developed by @abhishek_reddy</Typography>
            </Box>
            <Box>
                <Typography variant='h4'>Copyright © {year} AK</Typography>
            </Box>
            <Box display='flex' flexDirection='row' gap={9}>
                <Avatar sx={{ bgcolor: colors.heading[100] }}>
                    <a
                        href="https://www.linkedin.com/in/abhishek-reddy-b74852221/"
                        target="_blank"
                        rel="noreferrer"
                        className="icon-colour  home-social-icons"
                    >
                        <FaLinkedinIn />
                    </a>
                </Avatar>
                <Avatar sx={{ bgcolor: colors.heading[100] }}>
                    <a
                        href="https://github.com/abhishek-reddy-1999"
                        target="_blank"
                        rel="noreferrer"
                        className="icon-colour  home-social-icons"
                    >
                        <FaGithub />
                    </a>
                </Avatar>
                <Avatar sx={{ bgcolor: colors.heading[100] }}>
                    <a
                        href="https://www.instagram.com/kuppani_abhishek_reddy"
                        target="_blank"
                        rel="noreferrer"
                        className="icon-colour home-social-icons"
                    >
                        <RiInstagramLine />
                    </a>
                </Avatar>
            </Box>
        </Grid>
    )
}
